<template>
  <div id="app" :class="{ rtl: $i18n.locale === 'AR' }">
    <HomeHead></HomeHead>
    <Home></Home>
    <Accept />
  </div>
</template>

<script>
import Home from '@/components/home.vue'
import HomeHead from '@/components/common/homeHead/index.vue'
import Accept from '@/components/common/accept.vue'
export default {
  name: 'HomeApp',
  components: {
    HomeHead,
    Home,
    Accept,
  },
}
</script>
